<!--
 * @Author: chengleilei
 * @Date: 2022-04-20 16:55:49
 * @Description: 退款单列表弹窗
-->

<template>
    <Modal v-model="modal" title="退款单" :mask-closable="false" width="910" :closable="false">
        <table-page :hasPage="false" :list="list" />
        <div slot="footer">
            <Button type="text" @click="modalCancel">取消</Button>
        </div>
    </Modal>
</template>

<script>
import tablePage from '@/components/tablePage';
import { apiListRefundOrder } from '@/api/purchase';

export default {
    props: {},
    components: { tablePage },
    data() {
        return {
            modal: false, // 弹窗显隐
            item: {}, // 订单数据
            // 退款单列表
            list: {
                current: 1,
                size: window.$pageSize,
                total: 0,
                columns: [
                    {
                        title: '退款单号',
                        key: 'refundOrderNo',
                        minWidth: 205,
                        align: 'center',
                    },
                    {
                        title: '退款发起时间',
                        key: 'startTime',
                        minWidth: 170,
                        align: 'center',
                    },
                    {
                        title: '退款完成时间',
                        minWidth: 170,
                        align: 'center',
                        render: (h, p) => {
                            return [p.row.successTime || '-'];
                        },
                    },
                    {
                        title: '支付方式',
                        key: 'payTypeStr',
                        minWidth: 100,
                        align: 'center',
                    },
                    {
                        title: '退款总金额(元)',
                        key: 'totalAmount',
                        minWidth: 140,
                        align: 'center',
                    },
                    {
                        title: '积分退款(积分)',
                        minWidth: 140,
                        align: 'center',
                        render: (h, p) => {
                            return [p.row.scoreRefundAmount || '-'];
                        },
                    },
                    {
                        title: '三方支付退款(元)',
                        minWidth: 150,
                        align: 'center',
                        render: (h, p) => {
                            return [p.row.cpcnRefundAmount || '-'];
                        },
                    },
                    {
                        title: '退款状态',
                        key: 'refundStatusStr',
                        minWidth: 120,
                        align: 'center',
                    },
                    {
                        title: '交易流水号',
                        minWidth: 200,
                        align: 'center',
                        render: (h, p) => {
                            return [p.row.txSn || '-'];
                        },
                    },
                    {
                        title: '备注',
                        minWidth: 120,
                        align: 'center',
                        render: (h, p) => {
                            return [p.row.refundStatus == '30' ? p.row.remark : '-'];
                        },
                    },
                ],
                data: [],
            },
        };
    },
    methods: {
        /**
         * @description 弹窗打开
         */
        open(row) {
            this.modal = true;
            this.item = row;
            this.getRefundList(row.id);
        },

        /**
         * @description 查询退款单列表
         */
        getRefundList(id) {
            apiListRefundOrder(id).then((res) => {
                this.list.data = res || [];
            });
        },

        /**
         * @description 弹窗取消
         */
        modalCancel() {
            this.modal = false;
        },
    },
};
</script>

<style lang="less" scoped>
.info {
    span {
        color: #e70707;
    }
}
</style>
